import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import { Quill } from 'react-quill';
var Embed = Quill.import('blots/embed');
var ATTRIBUTES = ['data-variable'];
var SubstitutionVariablesBlot = /*#__PURE__*/function (_Embed) {
  _inheritsLoose(SubstitutionVariablesBlot, _Embed);
  function SubstitutionVariablesBlot() {
    return _Embed.apply(this, arguments) || this;
  }
  //making the tag a span causes the rte to break
  SubstitutionVariablesBlot.create = function create(data) {
    var node = _Embed.create.call(this);
    node.setAttribute('contenteditable', false);
    node.innerText = "{{" + data.variable + "}}";
    return SubstitutionVariablesBlot.setDataValues(node, data);
  };
  SubstitutionVariablesBlot.setDataValues = function setDataValues(element, data) {
    var domNode = element;
    Object.keys(data).forEach(function (key) {
      domNode.dataset[key] = data[key];
    });
    return domNode;
  };
  SubstitutionVariablesBlot.value = function value(domNode) {
    return domNode.dataset;
  };
  SubstitutionVariablesBlot.formats = function formats(domNode) {
    return ATTRIBUTES.reduce(function (formats, attribute) {
      if (domNode.hasAttribute(attribute)) {
        formats[attribute] = domNode.getAttribute(attribute);
      }
      return formats;
    }, {});
  };
  var _proto = SubstitutionVariablesBlot.prototype;
  _proto.format = function format(name, value) {
    if (ATTRIBUTES.indexOf(name) > -1) {
      this.domNode.setAttribute('data-variable', value);
      this.contentNode.innerText = "{{" + value + "}}";
    } else {
      _Embed.prototype.format.call(this, name, value);
    }
  };
  return SubstitutionVariablesBlot;
}(Embed);
SubstitutionVariablesBlot.blotName = 'substitutionVariables';
SubstitutionVariablesBlot.tagName = 'variable';
export default SubstitutionVariablesBlot;